import { RECEIVE_TESTIMONIALS, REQUEST_TESTIMONIALS } from '../actions'
import { RequestStatus } from '../helpers/request'

export default (
    state = {
        items: [],
        requestStatus: RequestStatus.IDLE,
    },
    action
) => {
    const { type, data } = action
    switch (type) {
        case REQUEST_TESTIMONIALS: {
            return { ...state, requestStatus: RequestStatus.PENDING }
        }
        case RECEIVE_TESTIMONIALS: {
            const { items } = data
            return { ...state, items, requestStatus: RequestStatus.RESOLVED }
        }
        default:
            return state
    }
}
